import { all, call, takeEvery } from 'redux-saga/effects';


const renameChallengeRenderTimeKey = obj => {
  if ('challengeRenderTime' in obj) {
    obj['render_time_msec'] = obj['challengeRenderTime'];
    delete obj['challengeRenderTime'];
  }
  return obj;
};

function* callGaType({ payload }) {
  const standardizedPayLoad = renameChallengeRenderTimeKey(payload);
}

export function* createGaSaga(types) {
  yield all([takeEvery(types.executeGA, callGaType)]);
}
